import { render, staticRenderFns } from "./BlacklistCheck.vue?vue&type=template&id=4493c5b5&scoped=true"
import script from "./BlacklistCheck.vue?vue&type=script&lang=js"
export * from "./BlacklistCheck.vue?vue&type=script&lang=js"
import style0 from "./BlacklistCheck.vue?vue&type=style&index=0&id=4493c5b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4493c5b5",
  null
  
)

export default component.exports